import bind from 'bind-decorator';
import ObjectStore from 'bz-stores/mobx/object-store';
import createContext from 'bz-utilities/hooks/context-v2';
import _ from 'lodash';
import { runInAction } from 'mobx';
import { DictionaryRequestAll, type SystemDictionary } from 'tm3-core/api.dtos';

export const [DictionaryStoreContext, useDictionaryStore] =
  createContext<DictionaryStore>('DictionaryStore');

class ObservableDictionaryStore extends ObjectStore<any, unknown> {
  constructor() {
    super();
    this.data = {};
  }

  load(data: any) {
    this.onLoad(data);
  }
}

export const DictionaryObservable = new ObservableDictionaryStore();

class DictionaryStore extends ObjectStore<any, unknown> {
  constructor(readonly location: 'aus' | 'can' | 'gbr' | 'eur' | 'gcc') {
    super();
    this.data = {};
  }

  async load() {
    const res = await this.client.get(new DictionaryRequestAll());
    const configDictionary: Record<string, any> = {
      vat: {
        aus: 'GST',
        can: 'GST',
        gbr: 'VAT',
        eur: 'VAT',
        gcc: 'VAT'
      }
    };
    runInAction(() => {
      res.results.map((row) => {
        row.key = row.key.replace(/[^a-zA-Z0-9']/g, '');
        row.key = row.key.toLowerCase();
        configDictionary[row.key] = row;
      });
      this.onLoad(configDictionary);
      DictionaryObservable.load(configDictionary);
    });
  }

  matchFirstLetterCasing(newWord: string, word: string) {
    if (word[0] === word[0].toUpperCase()) {
      newWord = newWord[0].toUpperCase() + newWord.substring(1);
    } else if (word[0] === word[0].toLowerCase()) {
      newWord = newWord[0].toLowerCase() + newWord.substring(1);
    }
    return newWord;
  }

  @bind
  word(word: string, count = 0, possessive = false) {
    const configDictionary = this.data;

    let returnWord: SystemDictionary = configDictionary[word.toLowerCase()];
    if (!returnWord) {
      for (let key in configDictionary) {
        if (word.toLowerCase().indexOf(key) === 0) {
          returnWord = configDictionary[key];
          if (_.isObject(returnWord)) {
            return this.matchFirstLetterCasing(
              (count > 1 ? returnWord.plural : returnWord.value) + word.substring(key.length),
              word
            );
          }
          break;
        }
      }
    }
    if (_.isObject(returnWord)) {
      if (word === 'VAT') {
        const location = this.location?.toLowerCase();
        return returnWord[location] ?? word;
      } else {
        return this.matchFirstLetterCasing(count > 1 ? returnWord.plural : returnWord.value, word);
      }
    } else if (returnWord) {
      return this.matchFirstLetterCasing(returnWord, word);
    }
    if (count <= 1) return word;

    const lastLetter = word.toLowerCase().charAt(word.length - 1);
    const lastLetters = word.toLowerCase().substring(word.length - 2);
    const suffix =
      ['s', 'x', 'z'].includes(lastLetter) || ['sh', 'ch'].includes(lastLetters) ? 'es' : 's';

    return word + suffix;
  }

  @bind
  format(str: string, number: number = 0) {
    return (str || '').replace(/\{(.*?)\}/g, (x) =>
      this.word(x.replace('{', '').replace('}', ''), number)
    );
  }
}

export default DictionaryStore;
